<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="pie-chart-outline"></nb-icon>
        <div class="ml-2" i18n>Insight Stats: {{ insight.id }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body>
    <h6 class="text-uppercase" i18n>Details</h6>
    <hr />
    <dl class="row small">
      <dt class="col-4" i18n>Insight Name:</dt>
      <dd class="col-6">{{ insight.name }}</dd>
      <br />
      <dt class="col-4" i18n>Creator:</dt>
      <dd class="col-6">{{ insight.created_by }}</dd>
      <br />
      <dt class="col-4" i18n>Time Created:</dt>
      <dd class="col-6">{{ convertUnixTime(insight.created_dttm) }}</dd>
      <br />
      <!--<dt class="col-2">Owner: </dt>
          <dd class="col-10">{{insight.owner}}</dd>-->
      <br />
    </dl>
    <h6 class="text-uppercase" i18n>Stats</h6>
    <hr />
    <dl class="row small">
      <dt class="col-4" i18n>Total Executions:</dt>
      <dd class="col-6">{{ insight.executions }}</dd>
      <br />
      <dt class="col-4" i18n>Average Execution Time:</dt>
      <dd class="col-6">{{ getAverageExecDuration() }}</dd>
      <br />
      <dt class="col-4" i18n>Total Publishes:</dt>
      <dd class="col-6">{{ insight.total_results }}</dd>
      <br />
      <dt class="col-4" i18n>Average Publishes Per Execution:</dt>
      <dd class="col-6">{{ getAveragePublishes() }}</dd>
      <br />
      <dt class="col-4" i18n>Last Insight Run:</dt>
      <dd class="col-6">{{ convertUnixTime(insight.last_run_time) }}</dd>
    </dl>
  </nb-card-body>
</nb-card>
